export {};

export const ModalsZIndex = 1000;
export const SideBarZIndex = 1051;
export const NotificationsZIndex = 1100;
